import React, { Component } from 'react';
import { isLogin } from "../utils/index";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
            <footer className="ebw-footer">
                <div className="ebw-section ebw-footer__inner">
                    <Container className="container-fluid">
                        <Row>
                            <Col xs="4" md="4" lg="2">
                                <div className="ebw-footer__wrap">
                                    <div className="ebw-footer__wrap-category">Company</div>
                                    <ul className="ebw-footer__list">
                                        <li className="ebw-footer__item">
                                            <a target="_blank" href="https://easybids.com/" className="ebw-footer__link">Easybids</a>
                                        </li>
                                        <li className="ebw-footer__item">
                                            <a target="_blank" href="https://easybids.com/service-provider/#provider-work" className="ebw-footer__link">How it works</a>
                                        </li>
                                        <li className="ebw-footer__item">
                                            <a target="_blank" href="https://blog.easybids.com/" className="ebw-footer__link">Blog</a>
                                        </li>
                                    </ul>
                                </div>
                            </Col>

                            <Col xs="4" md="4" lg="2">
                                <div className="ebw-footer__wrap">
                                    <div className="ebw-footer__wrap-category">Help</div>
                                    <ul className="ebw-footer__list">
                                        <li className="ebw-footer__item">
                                            <Link
                                                to={{ pathname: "https://easybids.com/consumer-faq" }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="ebw-footer__link"
                                            >
                                            FAQs
                                            </Link>
                                        </li>
                                        <li className="ebw-footer__item">
                                            <Link to="/support" className="ebw-footer__link">Support </Link>
                                        </li>
                                        {/* <li className="ebw-footer__item">
                                            <a target="_blank" href="https://www.lightstream.com/" className="ebw-footer__link">Get financing</a>
                                        </li> */}
                                    </ul>
                                </div>
                            </Col>

                            <Col xs="4" md="4" lg="2">
                                <div className="ebw-footer__wrap">
                                    <div className="ebw-footer__wrap-category">Services</div>
                                    <ul className="ebw-footer__list">
                                        <li className="ebw-footer__item">
                                            <a target="_blank" href="https://easybids.com/#services-home" className="ebw-footer__link">Line of services</a>
                                        </li>
                                        {/* <li className="ebw-footer__item">
                                            <a target="_blank" href="https://easybids.com/service-provider" className="ebw-footer__link">Know more</a>
                                        </li> */}
                                    </ul>
                                </div>
                            </Col>

                            <Col md={{ size: 2, offset: 2 }} lg={{ size: 2, offset: 0 }}>
                                <div className="text-center text-lg-right">
                                    <img alt='EasyBids - Home Improvement' className="ebw-footer__brand img-fluid mb-4" src="/images/logo.svg" />
                                </div>
                            </Col>

                            <Col md={{ size: 6, offset: 0 }} lg={{ size: 4, offset: 0 }}>
                                <div className="ebw-footer__wrap--store text-center text-lg-left">
                                    <div className="ebw-footer__wrap-category ebw-footer__wrap-category--available">Available on Mobile</div>
                                    <div className="d-flex align-items-center">
                                        <a className="ebw-footer__rgt-item" target="_blank" href="https://play.google.com/store/apps/details?id=easybids.provider.app">
                                            <img src="/images/icons/google-play.png" alt="Google Play" className="img-fluid d-block" />
                                        </a>

                                        <a className="ebw-footer__rgt-item ml-2" target="_blank" href="https://apps.apple.com/us/app/easybids-pro-get-contracts/id1511563795">
                                            <img src="/images/icons/apple-store.png" alt="App Store" className="img-fluid d-block" />
                                        </a>
                                    </div>
                                </div>
                            </Col>

                            <Col sm="12">
                                <div className="ebw-footer__address">
                                    <div className="ebw-footer__address-info d-flex flex-wrap justify-content-center justify-content-lg-between align-items-center">
                                        <div className="ebw-footer__address-desc p-2 mb-0">USA, San Diego, CA</div>

                                        <div className="d-flex flex-wrap justify-content-center">
                                            <a href="mailto:info@easybids.com" className="ebw-footer__address-link p-2">info@easybids.com</a>
                                            <a href="tel:(888) 598-1187" className="ebw-footer__address-link p-2">(888) 598-1187</a>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className="ebw-footer__btm">
                    <div className="ebw-footer__btm-inner">
                        <Container>
                            <Row>
                                <Col sm="12">
                                    <div className="ebw-footer__copyright d-flex flex-column flex-md-row justify-content-center align-items-center">
                                        <div className="ebw-footer__copyright-lft d-flex flex-column flex-md-row justify-content-center align-items-center">
                                            {/* <Link className="ebw-footer__brand" to="/dashboard">
                                                <img src="/images/logo.svg" alt="Logo" className="img-fluid d-block" />
                                            </Link> */}

                                            <div className="ebw-footer__copyright-desc text-sm pl-md-4">
                                                © 2008 - 2021. All rights reserved.
                                            </div>
                                        </div>

                                        <div className="ebw-footer__copyright-rgt ml-md-auto">
                                            <Link to="/terms-conditions" className="ebw-footer__copyright-link text-sm">
                                                Terms & Conditions
                                            </Link>

                                            <Link to="/privacy-policy" className="ebw-footer__copyright-link text-sm pl-3">
                                                Privacy Policy
                                            </Link>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </footer>
    )
}

export default Footer